React = require('react')
GenericContent = require('../../modules/generic-content')

module.exports = React.createClass
    render: ->
        return (
            React.createElement("div", {"className": "intro"},
                React.createElement(GenericContent, {"title": "Build from scratch"}, """
                    TBD. I\'ll record the build process here.
""")
            )
        )



/** WEBPACK FOOTER **
 ** ./~/cjsx-loader!./src/scripts/components/pages/examples/intro.cjsx
 **/